export default __webpack_public_path__ + "static/tweet-one-a15940f4b4a272abb40a121e65d5dd5f.png";